import { jsPDF } from "jspdf";
import { qrDataUrl } from "./qrDataUrl";

const CARD_WIDTH = 3.375;
const CARD_HEIGHT = 2.125;
const NAVY = [6, 66, 96];

const formatReference = (card) => card?.publicReference || "—";

export const downloadMemberCardPdf = async ({ card, clientName }) => {
  const reference = formatReference(card);
  const qrToken = card?.qrToken;
  const qrImage = qrToken ? await qrDataUrl(qrToken, 360) : "";

  const pdf = new jsPDF({
    format: [CARD_WIDTH, CARD_HEIGHT],
    orientation: "landscape",
    unit: "in",
  });

  const paintFront = () => {
    pdf.setFillColor(...NAVY);
    pdf.rect(0, 0, CARD_WIDTH, CARD_HEIGHT, "F");
    pdf.setTextColor(255, 255, 255);
    pdf.setFont("helvetica", "bold");
    pdf.setFontSize(11);
    pdf.text("TeleTrace", 0.18, 0.32);
    pdf.setFont("helvetica", "normal");
    pdf.setFontSize(7);
    pdf.text("MEMBER CARD", CARD_WIDTH - 0.18, 0.32, { align: "right" });
    pdf.setFont("helvetica", "bold");
    pdf.setFontSize(14);
    pdf.text(clientName || "Client", 0.18, 1.05, { maxWidth: 1.9 });
    pdf.setFont("helvetica", "normal");
    pdf.setFontSize(8.5);
    pdf.text(`ID: ${reference}`, 0.18, 1.32);
    pdf.setTextColor(210, 224, 230);
    pdf.setFontSize(7);
    pdf.text("Scan to verify visit", 0.18, 1.78);
    if (qrImage) {
      pdf.setFillColor(255, 255, 255);
      pdf.rect(2.08, 0.48, 1.14, 1.14, "F");
      pdf.addImage(qrImage, "PNG", 2.16, 0.56, 0.98, 0.98);
    }
  };

  const paintBack = () => {
    pdf.setFillColor(...NAVY);
    pdf.rect(0, 0, CARD_WIDTH, CARD_HEIGHT, "F");
    pdf.setTextColor(255, 255, 255);
    pdf.setFont("helvetica", "bold");
    pdf.setFontSize(10);
    pdf.text("TeleTrace", 0.16, 0.28);
    pdf.setFont("helvetica", "normal");
    pdf.setFontSize(7);
    pdf.text("MEMBER CARD", CARD_WIDTH - 0.16, 0.28, { align: "right" });
    if (qrImage) {
      pdf.addImage(qrImage, "PNG", 2.05, 0.48, 1.14, 1.14);
    }
    pdf.setFont("helvetica", "bold");
    pdf.setFontSize(9);
    pdf.text(reference, 0.16, 0.7);
    pdf.setFont("helvetica", "normal");
    pdf.setFontSize(7);
    pdf.text("Scan to confirm visit service delivery.", 0.16, 0.95, {
      maxWidth: 1.75,
    });
    pdf.text("teletrace.com", 0.16, 1.45);
    pdf.setFontSize(5.5);
    pdf.text(
      "This card identifies a TeleTrace client for visit confirmation only. Do not share this QR code.",
      0.16,
      1.72,
      { maxWidth: 1.75 }
    );
  };

  paintFront();
  pdf.addPage([CARD_WIDTH, CARD_HEIGHT], "landscape");
  paintBack();
  pdf.save(`TeleTrace-Member-Card-${reference}.pdf`);
};
